import { render, staticRenderFns } from "./dashboardAchievementsModal.vue?vue&type=template&id=f49518b4&"
import script from "./dashboardAchievementsModal.vue?vue&type=script&lang=js&"
export * from "./dashboardAchievementsModal.vue?vue&type=script&lang=js&"
import style0 from "./dashboardAchievementsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports